import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

export interface ProfileImportAnalyzeFileResultDto {
  total: number;
  columns: string[];
}

export interface ProfileImportRowErrorDto {
  row: number;
  errors: string[];
}

export interface ProfileImportResultDto {
  total: number;
  enqueued: number;
  invalid: number;
  errors: ProfileImportRowErrorDto[];
}

@Injectable({
  providedIn: 'root',
})
export class ImportService {
  private readonly http = inject(HttpClient);

  public analyzeFile(file: File): Observable<ProfileImportAnalyzeFileResultDto> {
    const formData = new FormData();
    formData.append('file', file);

    return this.http.post<ProfileImportAnalyzeFileResultDto>('/admin/import/analyze-file', formData);
  }

  public importProfiles(
    file: File,
    portalId: number,
    mapping: Record<string, string>,
    convertFromString: string[] = [],
  ): Observable<ProfileImportResultDto> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('portalId', String(portalId));
    formData.append('mapping', JSON.stringify(mapping));
    if (convertFromString.length > 0) {
      formData.append('convertFromString', convertFromString.join(','));
    }

    return this.http.post<ProfileImportResultDto>('/admin/import/profiles', formData);
  }
}
